module.exports = __webpack_public_path__ + "img/overview_brand_02.6725ff8e.jpg";